import { create } from 'zustand';
import { fetchEasykitDriverTasks } from '@/api/easykit';
import type { EasykitDriverTask } from '@/types/odoo';

interface EasykitDriverState {
  tasks: EasykitDriverTask[];
  loading: boolean;
  error: string | null;
  dayOffset: number; // 0 = today, 1-5 ahead

  fetchTasks: () => Promise<void>;
  setDayOffset: (offset: number) => void;
}

export const useEasykitDriverStore = create<EasykitDriverState>((set) => ({
  tasks: [],
  loading: false,
  error: null,
  dayOffset: 0,

  fetchTasks: async () => {
    set({ loading: true, error: null });
    try {
      const tasks = await fetchEasykitDriverTasks();
      set({ tasks, loading: false });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Taken ophalen mislukt';
      set({ error: message, loading: false });
    }
  },

  setDayOffset: (offset) => set({ dayOffset: Math.max(0, Math.min(5, offset)) }),
}));
